import {
  Country,
  countryNames,
  getProvinceNameFromCode,
  Province,
  State,
  stateNames,
  SupportedLanguageCode,
} from '@emma-labs/shared/typescript';

export function formatOptionalCountryStateAndTerritory(
  country: Country | undefined,
  state: Province | State | undefined,
  territory: string | undefined,
  languageCode: SupportedLanguageCode,
): string {
  let str = '';

  if (country) {
    str += countryNames[country][languageCode];
  }
  if (state && country === Country.CA) {
    str += ` - ${getProvinceNameFromCode(state as Province, languageCode === 'fr')}`;
  } else if (state && country === Country.US) {
    str += ` - ${stateNames[state as State][languageCode]}`;
  }
  if (territory) {
    str += str ? ` (${territory})` : territory;
  }

  return str;
}
